'use strict';

function highlightDifferences(original, suggestion) {
    // Create temporary elements to work with HTML
    var originalDiv = document.createElement('div');
    var suggestionDiv = document.createElement('div');
    
    // Store for shortcode mappings
    var shortcodeMappings = {};
    var counter = 0;
    
    // Function to create unique identifier (same as in helpersFunction.js)
    function createPlaceholder(type) {
        return '<span id="shortcode_' + type + '_' + (counter++) + '"></span>';
    }
    
    // Replace shortcodes with placeholders
    function replaceShortcodes(content) {
        return content
            // Handle caption blocks
            .replace(/<captionblock[^>]*>[\s\S]*?<\/captionblock>/g, function(match) {
                var placeholder = createPlaceholder('caption');
                shortcodeMappings[placeholder] = match;
                return placeholder;
            })
            // Handle gallery blocks
            .replace(/<galleryblock[^>]*>[\s\S]*?<\/galleryblock>/g, function(match) {
                var placeholder = createPlaceholder('gallery');
                shortcodeMappings[placeholder] = match;
                return placeholder;
            })
            // Handle embed blocks
            .replace(/<embedblock[^>]*>[\s\S]*?<\/embedblock>/g, function(match) {
                var placeholder = createPlaceholder('embed');
                shortcodeMappings[placeholder] = match;
                return placeholder;
            });
    }
    
    // Replace shortcodes in both original and suggestion
    original = replaceShortcodes(original);
    suggestion = replaceShortcodes(suggestion);
    
    // Preserve block elements inside paragraphs by wrapping them in a special container
    function preserveBlockElements(content) {
        return content.replace(/<p>([\s\S]*?)<\/p>/g, function(match, content) {
            // If paragraph contains block elements, wrap them in a special container
            if (/<(?:ul|ol)[^>]*>/i.test(content)) {
                return '<div class="preserve-paragraph">' + content + '</div>';
            }
            return match;
        });
    }
    
    original = preserveBlockElements(original);
    suggestion = preserveBlockElements(suggestion);
    
    originalDiv.innerHTML = original;
    suggestionDiv.innerHTML = suggestion;

    // Function to get text content with positions and parent elements
    function getTextWithContext(element) {
        var result = [];
        
        function traverse(node, parentPath) {
            parentPath = parentPath || '';
            
            // Skip processing of shortcode placeholders
            if (node.id && node.id.startsWith('shortcode_')) {
                return;
            }
            
            // Handle preserved paragraphs
            if (node.classList && node.classList.contains('preserve-paragraph')) {
                result.push({
                    text: node.innerHTML,
                    node: node,
                    parentPath: parentPath,
                    isPreserved: true
                });
                return;
            }
            
            if (node.nodeType === Node.TEXT_NODE) {
                var text = node.textContent;
                if (text.trim()) {
                    result.push({
                        text: text,
                        node: node,
                        parentPath: parentPath
                    });
                }
            }
            if (node.childNodes) {
                var currentPath = parentPath + (node.nodeName || '') + '>';
                Array.from(node.childNodes).forEach(function(child) {
                    traverse(child, currentPath);
                });
            }
        }
        
        traverse(element);
        return result;
    }

    // Get text content from both elements
    var originalTexts = getTextWithContext(originalDiv);
    var suggestionTexts = getTextWithContext(suggestionDiv);

    // Function to normalize text for comparison
    function normalizeText(text) {
        return text.normalize('NFC'); // Normalize to composed form
    }

    // Compare and highlight differences
    for (var i = 0; i < suggestionTexts.length; i++) {
        var suggestionText = suggestionTexts[i];
        var originalText = originalTexts[i];

        // Skip processing for preserved content
        if (suggestionText.isPreserved) {
            continue;
        }

        if (!originalText || normalizeText(suggestionText.text) !== normalizeText(originalText.text)) {
            // Use diff-match-patch to find differences
            var dmp = new diff_match_patch();
            var diffs = dmp.diff_main(
                originalText ? normalizeText(originalText.text) : '', 
                normalizeText(suggestionText.text)
            );
            dmp.diff_cleanupSemantic(diffs);

            if (diffs.length > 0) {
                var textNode = suggestionText.node;
                if (textNode) {
                    var parent = textNode.parentNode;
                    var newNodes = [];

                    diffs.forEach(function(diff) {
                        if (diff[0] === 1) { // Insertion
                            var span = document.createElement('span');
                            span.className = 'diff';
                            span.style.backgroundColor = '#a3e4a3';
                            span.textContent = diff[1];
                            newNodes.push(span);
                        } else if (diff[0] === 0) { // Equal
                            newNodes.push(document.createTextNode(diff[1]));
                        }
                    });

                    // Replace the original node with new nodes
                    newNodes.forEach(function(node) {
                        parent.insertBefore(node, textNode);
                    });
                    parent.removeChild(textNode);
                }
            }
        }
    }

    // Restore original shortcodes and paragraph structure
    var result = suggestionDiv.innerHTML;
    
    // First restore shortcodes
    Object.keys(shortcodeMappings).forEach(function(placeholder) {
        result = result.replace(placeholder, shortcodeMappings[placeholder]);
    });
    
    // Then restore paragraph structure
    result = result.replace(/<div class="preserve-paragraph">([\s\S]*?)<\/div>/g, function(match, content) {
        return '<p>' + content + '</p>';
    });
    
    return result;
}
function cyrillicToLatin(content) {
    // Serbian Cyrillic to Latin mapping
    var cyrillicToLatin = {
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'ђ': 'đ', 'е': 'e', 'ж': 'ž', 'з': 'z',
        'и': 'i', 'ј': 'j', 'к': 'k', 'л': 'l', 'љ': 'lj', 'м': 'm', 'н': 'n', 'њ': 'nj', 'о': 'o',
        'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'ћ': 'ć', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c',
        'ч': 'č', 'џ': 'dž', 'ш': 'š',
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Ђ': 'Đ', 'Е': 'E', 'Ж': 'Ž', 'З': 'Z',
        'И': 'I', 'Ј': 'J', 'К': 'K', 'Л': 'L', 'Љ': 'Lj', 'М': 'M', 'Н': 'N', 'Њ': 'Nj', 'О': 'O',
        'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'Ћ': 'Ć', 'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C',
        'Ч': 'Č', 'Џ': 'Dž', 'Ш': 'Š'
    };
      
    // Convert Cyrillic to Latin while preserving existing Latin characters
    var latinContent = content.replace(/[а-шА-ШЂЉЊЋЏђљњћџ]/g, function(match) {
        return cyrillicToLatin[match] || match;
    });
    return latinContent;
}
var shortcodeStore = {};
function specifiedShortcodePlaceholderEditorContent(content, shortcodes) {
    var placeholderCounter = 0;
    shortcodeStore = {};
    // Define which shortcodes to preserve
    var preserveShortcodes = shortcodes;
    // Create regex pattern for the specified shortcodes
    var shortcodePattern = new RegExp('<(' + preserveShortcodes.join('|') + ')[^>]*>([\\s\\S]*?)<\\/\\1>', 'g');
                
    // Replace specified shortcodes with placeholders
    content = content.replace(shortcodePattern, function(match, tag) {
      var placeholder = 'SHORTCODE_PLACEHOLDER_' + placeholderCounter;
      shortcodeStore[placeholder] = match;
      placeholderCounter++;
      return placeholder;
    });
    return content;
}
function specifiedShortcodeRestoreEditorContent(content) {
   // Restore all other shortcodes
   for (var placeholder in shortcodeStore) {
    content = content.replace(placeholder, shortcodeStore[placeholder]);
  }
  return content;
}

module.exports = {
    highlightDifferences: highlightDifferences,
    cyrillicToLatin: cyrillicToLatin,
    specifiedShortcodePlaceholderEditorContent: specifiedShortcodePlaceholderEditorContent,
    specifiedShortcodeRestoreEditorContent: specifiedShortcodeRestoreEditorContent
};




//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/globalHelpres.js
// module id = 18
// module chunks = 0